import type { ComponentType } from 'react'

/**
 * Name -> Lader. Neue montierbare Komponenten kommen hier dazu; der
 * Entrypoint schlägt Elemente über `data-react-component` nach.
 *
 * Ein *Lader* und keine Komponente: `entrypoints/application.ts` ist der
 * einzige Vite-Einstieg, also landet alles, was diese Datei statisch
 * importiert, in dem Bündel, das die Startseite, die Preisseite, das
 * Impressum, der Katalog und die Kontoseite herunterladen. Die beiden
 * Komponenten unten bringen zusammen paper.js, dnd-kit, lucide-react und
 * file-saver mit -- für zwei Ansichten von rund vierzig. `import()` legt
 * jede in ein eigenes Bündel, das nur geholt wird, wo es auf der Seite eine
 * Montagestelle dafür gibt (F-12).
 */
export type ComponentLoader = () => Promise<{ default: ComponentType<any> }>

export const registry: Record<string, ComponentLoader> = {
  // Nicht `../editor/Editor`, sondern die kleine Hülle davor: sie zeigt das
  // Skelett, während das große Bündel unterwegs ist (siehe EditorMount.tsx).
  Editor: () => import('../editor/EditorMount'),
  ProjectsDashboard: () => import('./ProjectsDashboard'),
  // Der Gast-Trichter (/ausprobieren, /ausprobieren/ergebnis) und der
  // öffentliche Dateicheck (/svg-pruefen). Drei eigene Bündel und nicht eines:
  // wer nur das Formular sieht, soll nicht den Doktor mitladen, und wer die
  // Datei prüft, nicht das Ergebnis-Layout.
  GuestTrace: () => import('./GuestTrace'),
  GuestResult: () => import('./GuestResult'),
  SvgFileCheck: () => import('./SvgFileCheck'),
  // Die Landestelle der Dateizuordnung (/datei-oeffnen). Eigenes Bündel wie
  // die drei darüber: die Seite besteht aus einer Statuszeile und braucht
  // nichts von dem, was das Dashboard mitbringt.
  FileLaunch: () => import('./FileLaunch'),
}
